<template>
  <div>
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-row>
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  label-for="admissionRoundId"
                >
                  <v-select
                    v-model="filter.admissionRoundId"
                    :options="admissionRounds"
                    :reduce="option => option.value"
                    placeholder="Đợt xét tuyển"
                    @input="readAdmissionForm"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label-for="admissionFormId"
                >
                  <v-select
                    id="admissionFormId"
                    v-model="filter.admissionFormId"
                    :options="dataListAdmissionForm"
                    :reduce="option => option.value"
                    placeholder="Phương thức xét tuyển"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                lg="4"
              >
                <b-row>
                  <b-col
                    cols="12"
                    class="text-right"
                  >
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      size="sm"
                      class="mr-1"
                      @click="btnSearchClick()"
                    >
                      <feather-icon
                        icon="SearchIcon"
                        class="align-text-top"
                      />
                      Tìm kiếm
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      v-b-modal.saveModal
                      variant="success"
                      size="sm"
                      class=""
                      @click="onCreate"
                    >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="PlusIcon" /> Thêm mới
                    </span>
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="">
              <b-col cols="12">
                <vue-good-table
                  mode="remote"
                  class="my-table"
                  row-style-class="vgt-row"
                  style-class="vgt-table striped bordered"
                  :columns="columns"
                  :rows="admissionRevenueSchedule"
                  :pagination-options="paginationOptions"
                  :total-rows="totalRows"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                  <span v-if="props.column.field === 'status'">
                    {{ getStatusName(props.row.status) }}
                  </span>
                    <span v-else-if="props.column.field === 'price'">
                      {{ new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(props.row.price) }}
                    </span>

                    <span
                      v-else-if="props.column.field === 'action'"
                      class="thead-group-action"
                    >
                    <b-button-group>
                      <b-button
                        v-if="updatable"
                        v-b-modal.saveModal
                        variant="primary"
                        class="btn-icon"
                        size="sm"
                        @click="onEdit(props.row)"
                      >
                        <feather-icon icon="Edit2Icon" />
                      </b-button>
                      <b-button
                        v-if="deletable"
                        variant="danger"
                        class="btn-icon"
                        size="sm"
                        @click="onDelete(props.row)"
                      >
                        <feather-icon icon="TrashIcon" />
                      </b-button>
                    </b-button-group>
                  </span>
                    <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                  </template>
                  <template
                    slot="pagination-bottom"
                    slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center ml-1 mb-1 mt-1">
                      <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                        đến {{ filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                      </span>
                      </div>
                      <div class="d-flex align-items-center mb-1 mt-1">
                        <span class="text-nowrap"> Hiển thị </span>
                        <b-form-select
                          v-model="filter.itemsPerPage"
                          :options="itemsPerPageOptions"
                          class="mx-1"
                          @input="(value) => props.perPageChanged({ currentPerPage: value })"
                        />
                        <span class="text-nowrap"> bản ghi/trang</span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="totalRows"
                          :per-page="filter.itemsPerPage"
                          class="mt-1 mb-0"
                          @input="(value) => props.pageChanged({ currentPage: value })"
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
      <b-modal
        ref="modal-save"
        id="modal-save"
        ok-only
        ok-title="Chấp nhận"
        centered
        size="lg"
        title="Thêm/Sửa dự kiến thu"
        :hide-footer=true
      >
        <RevenueScheduleSave @succeed="onSucceed" :revenueSchedule="currentAdmissionRevenueSchedule" />
      </b-modal>
    </b-container>
  </div>

</template>

<script>
import {
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BFormGroup,
  BFormSelect,
  BOverlay,
  BPagination,
  BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { showSuccessToast, showErrorToast } from '@/utils/notification'
import '@core/scss/vue/libs/vue-good-table.scss'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import RevenueScheduleSave from '@/views/admission/revenue-schedule/RevenueScheduleSave'
import { getUser } from '@/auth/utils'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'

export default {
  name: 'Index',
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BButtonGroup,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    BFormGroup,
    VueGoodTable,
    vSelect,
    RevenueScheduleSave,
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        organizationId: getUser().orgId,
        admissionRoundId: null,
        admissionFormId: null,
        sort: '',
      },
      currentAdmissionRevenuePlan: undefined,
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      admissionRevenueSchedules: [],
      currentAdmissionRevenueSchedule: {}
    }
  },
  computed: {
    ...mapGetters({
      totalRows: 'admissionRevenueSchedule/totalRows',
      statuses: 'admissionRound/statuses',
      admissionRevenuePlans: 'admissionRevenuePlan/admissionRevenuePlans',
      admissionRounds: 'admissionRound/admissionRoundsByOrganization',
      dataListAdmissionForm: 'admissionForm/admissionFormByAdmissionRoundId',
      admissionRevenueSchedule: 'admissionRevenueSchedule/admissionRevenueSchedule',
    }),
    columns() {
      return [
        {
          label: 'STT',
          field: 'rowNum',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Phương thức xét tuyển',
          field: 'admissionFormName',
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Tên khoản thu',
          field: 'admissionRevenueName',
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Số tiền khoản thu',
          field: 'price',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Bắt đầu',
          field: 'startAt',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Kết thúc',
          field: 'endAt',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Trạng thái',
          field: 'status',
          filterOptions: {
            placeholder: 'Tất cả',
            enabled: true,
            trigger: 'enter',
            filterDropdownItems: this.statusFilterDropdownItems,
          },
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: '',
          field: 'action',
          width: '80px',
          sortable: false,
          tdClass: 'text-center',
        },
      ]
    },
    statusFilterDropdownItems() {
      return this.statuses.map(status => ({
        value: status.value,
        text: status.label
      }))
    },
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.ADMISSION_REVENUE)
    },
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.ADMISSION_REVENUE)
    },
    deletable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.ADMISSION_REVENUE)
    },

  },
  async created() {
    this.isLoading = true
    try {
      await this.getAdmissionRoundsByOrganization({ organizationId: getUser().orgId })
    } catch ( e ) {
      showErrorToast(this, e)
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapActions({
      readAdmissionFormByAdmissionRoundId: 'admissionForm/readAdmissionFormByAdmissionRoundId',
      getAdmissionRoundsByOrganization: 'admissionRound/readAdmissionRoundsByOrganization',
      readAdmissionRevenueSchedule: 'admissionRevenueSchedule/readAdmissionRevenueSchedule',
      deleteAdmissionRevenueSchedule: 'admissionRevenueSchedule/deleteAdmissionRevenueSchedule',
    }),
    async readAdmissionForm(id) {
      await this.readAdmissionFormByAdmissionRoundId({ admissionRoundId: id })
    },
    async btnSearchClick() {
      this.isLoading = true
      try {
        await Promise.all([
          this.readAdmissionRevenueSchedule(this.filter),
        ])
      } catch ( e ) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    onCreate() {
      this.$bvModal.show('modal-save')
      this.currentAdmissionRevenueSchedule = null
    },
    onEdit(admissionRevenuePlan) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = admissionRevenuePlan
      this.$bvModal.show('modal-save')
      this.currentAdmissionRevenueSchedule = rest
    },
    onDelete(admissionRevenuePlan) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa kế hoạch thu của khoản thu <span class="text-danger">${admissionRevenuePlan.admissionRevenueName}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if ( result.value ) {
            this.isLoading = true
            try {
              const response = await this.deleteAdmissionRevenueSchedule(admissionRevenuePlan.id)
              if ( response ) {
                const {
                  isSuccessful,
                  message
                } = response
                if ( isSuccessful ) {
                  showSuccessToast(this, message)
                  try {
                    await this.readAdmissionRevenueSchedule(this.filter)
                  } catch ( e ) {
                    showErrorToast(this, e)
                  }
                } else {
                  showErrorToast(this, message)
                }
              }
            } catch ( e ) {
              showErrorToast(this, e)
            } finally {
              this.isLoading = false
            }
          }
        })
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getDataFromStore()
    },
    async getDataFromStore() {
      this.isLoading = true
      try {
        await this.readAdmissionRevenueSchedule(this.filter)
      } catch ( e ) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },

    async onPerPageChange(param) {
      this.updateParams({
        currentPage: param.currentPage,
        itemsPerPage: param.currentPerPage
      })
      await this.getDataFromStore()
    },

    async onSortChange(param) {
      if ( param.length > 0 ) {
        const {
          field,
          type
        } = param[0]
        if ( field === 'name' ) this.updateParams({ sort: `1_${type}` })
        else if ( field === 'code' ) this.updateParams({ sort: `2_${type}` })
        else if ( field === 'orderNo' ) this.updateParams({ sort: `3_${type}` })
        else this.updateParams({ sort: `3_${type}` })
      }
      await this.getDataFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if ( Object.hasOwn(columnFilters, 'status') ) this.updateParams({ status: columnFilters.status })
      await this.getDataFromStore()
    },
    getStatusName(id) {
      return this.statuses.find(status => status.value === id).label
    },
    async onSucceed() {
      this.$bvModal.hide('modal-save')
      await this.getDataFromStore()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
